import { Ticker, type TickerProps } from 'motion-plus/react'
import { type ReactNode } from 'react'

export default function TickerOverflowLoop({
	items,
	...props
}: Omit<TickerProps, 'items'> & {
	items: ReactNode[]
}) {
	return <Ticker items={items} overflow {...props} />
}
